import React, { useState, useEffect } from 'react';
import Api, { formatUrl } from '@plone/volto/helpers/Api/Api';
import { getBaseUrl } from '@plone/volto/helpers/Url/Url';
import { MPFLink } from 'volto-ministerio-publico-federal/components/UI';

const DefaultPageEditBanner = ({ pathname }) => {
  const [defaultPageId, setDefaultPageId] = useState(null);

  useEffect(() => {
    if (!pathname) return;
    const contentPath = getBaseUrl(pathname);
    const parentPath = contentPath.substring(0, contentPath.lastIndexOf('/'));
    if (!parentPath) return;

    const api = new Api();
    api
      .get(`${formatUrl(parentPath)}/@default-page`)
      .then((res) => setDefaultPageId(res.defaultPage))
      .catch(() => {});
  }, [pathname]);

  if (!defaultPageId || !pathname) return null;

  const contentPath = getBaseUrl(pathname);
  const itemId = contentPath.split('/').pop();
  if (itemId !== defaultPageId) return null;

  const parentPath = contentPath.substring(0, contentPath.lastIndexOf('/'));

  return (
    <div
      role="alert"
      className="mpf-alert mpf-alert-info"
      style={{ marginBottom: '16px' }}
    >
      <span>
        Você está editando a visão padrão da pasta.{' '}
        {/* `?pasta=1` desliga o redirect da pasta para o item padrão
            (ver Edit.jsx customizado) — sem isso este link voltaria
            direto para cá, em loop. */}
        <MPFLink href={`${parentPath}/edit?pasta=1`}>Clique aqui</MPFLink> para
        editar a pasta.
      </span>
    </div>
  );
};

export default DefaultPageEditBanner;
